module.exports = __webpack_public_path__ + "static/media/promo2.16bacf32.svg";